import { Affix, Center, Group, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useEffect, useState } from "react";

interface GridHeaderProps {
	children: React.ReactNode;
}

const GridHeader: React.FC<GridHeaderProps> = ({ children }) => {
	const theme = useMantineTheme();
	const [headerOpacity, setHeaderOpacity] = useState(1);
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	useEffect(() => {
		const handleScroll = () => {
			const scrollY = window.scrollY;
			let newOpacity = 1 - Math.min(scrollY / 200, 0.7); // Minimum opacity 0.3
			if (newOpacity < 0.3) newOpacity = 0.3;
			setHeaderOpacity(newOpacity);
		};
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const handleMouseEnter = () => {
		setHeaderOpacity(1);
	};

	const handleMouseLeave = () => {
		const scrollY = window.scrollY;
		let newOpacity = 1 - Math.min(scrollY / 200, 0.7);
		if (newOpacity < 0.3) newOpacity = 0.3;
		setHeaderOpacity(newOpacity);
	};

	return (
		<Affix position={{ top: 50, left: 0, right: 0 }} w={"100%"}>
			<Center w={"100%"}>
				<Group
					align="center"
					justify="center"
					mt={30}
					mb={30}
					style={{
						backgroundColor: theme.colors.blue[8],
						display: "flex",
						width: isMobile ? "90%" : "50%",
						borderRadius: "20px",
						transition: "background-color 0.2s, opacity 0.2s",
						opacity: headerOpacity,
					}}
					wrap="nowrap"
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					{children}
				</Group>
			</Center>
		</Affix>
	)
}

export default GridHeader


